import { DynamicLink, Flex, IconTypes } from "@capioweb/ui-components/src"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { BlockCommonLayout } from "../../utils/layout"
import { RelatedUnitCard } from "./RelatedUnitCard"

interface RelatedUnitsBlockProps {
	heading: StringProperty
	preamble: StringProperty
	relatedUnits: RelatedUnit[]
}

export interface RelatedUnit {
	icon: IconTypes
	name: string
	url: string
}

const RelatedUnitsBlock: React.FC<RelatedUnitsBlockProps> = ({
	heading,
	preamble,
	relatedUnits,
}) => {
	return (
		<BlockCommonLayout heading={heading} description={preamble}>
			<Flex
				w={1}
				columnGap={{ m: 3 }}
				rowGap={{ _: 1, m: 3 }}
				flexWrap="wrap"
				justifyContent={relatedUnits.length < 3 && "center"}
			>
				{relatedUnits.map((unit, i) => {
					return (
						<Flex
							w={1}
							flexGrow={0}
							flexShrink={1}
							flexBasis={{
								_: "100%",
								m: "calc(100% / 2 - 12px)",
								l: "calc(100% / 3 - 16px)",
							}}
							key={i}
							minh={9.75}
						>
							<DynamicLink
								url={unit?.url ?? "#"}
								style={{ width: "100%", height: "100%" }}
							>
								<RelatedUnitCard
									icon={unit.icon ? (unit.icon as IconTypes) : null}
									name={unit.name}
									firstChild={i === 0}
									lastChild={i === relatedUnits.length - 1}
								/>
							</DynamicLink>
						</Flex>
					)
				})}
			</Flex>
		</BlockCommonLayout>
	)
}

export { RelatedUnitsBlock }
